import { BusinessDay } from 'lightweight-charts';

export function toFixedIfNecessary(value: string | number, dp = 4): number {
  return +parseFloat(String(value)).toFixed(dp);
}

export function thousandSeparator(
  amount: number | string | undefined,
  decimalPlaces?: number,
) {
  if (typeof amount === `undefined`) {
    return 0;
  }
  if (typeof amount === `number`) {
    // eslint-disable-next-line no-param-reassign
    amount = toFixedIfNecessary(Math.abs(amount), decimalPlaces ?? 0);
  }
  const parts = amount.toString().split(`.`);
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, `,`);
  return parts.join(`.`);
}

type AddSignOption = {
  negativeSign: string;
  positiveSign: string;
  wrapWithParentheses: boolean;
};
export function addSign(n: number, option?: Partial<AddSignOption>): string {
  const defaultOption = {
    negativeSign: `-`,
    positiveSign: `+`,
    wrapWithParentheses: false,
  };
  const { negativeSign, positiveSign, wrapWithParentheses } = {
    ...defaultOption,
    ...option,
  };
  const absNumber = Math.abs(n);
  const number = wrapWithParentheses ? `${absNumber})` : absNumber;
  return `${wrapWithParentheses ? `(` : ``}${
    n < 0 ? negativeSign : positiveSign
  } ${number}`;
}

export function ellipseAddress(address = ``, width = 5): string {
  return `${address.slice(0, width)}...${address.slice(-width)}`;
}

export function toFixedTrunc(x: string | number, n: number): string | null {
  if (!x) return null;

  const v = (typeof x === `string` ? x : x.toString()).split(`.`);
  if (n <= 0) return v[0];
  let f = v[1] || ``;
  if (f.length > n) return `${v[0]}.${f.substr(0, n)}`;
  while (f.length < n) f += `0`;
  return `${v[0]}.${f}`;
}

export function businessDayToString(businessDay: BusinessDay) {
  return new Date(
    Date.UTC(businessDay.year, businessDay.month - 1, businessDay.day, 0, 0, 0),
  ).toLocaleDateString();
}
